
const firebaseConfig = {
  apiKey: "AIzaSyAZ6al0AJRV56hrpzKOGzmISfRGoa9iyfA",
  authDomain: "shriyam-b7767.firebaseapp.com",
  databaseURL: "https://shriyam-b7767.firebaseio.com",
  projectId: "shriyam-b7767",
  storageBucket: "shriyam-b7767.appspot.com",
  messagingSenderId: "858606597425",
  appId: "1:858606597425:web:c1583a6c8edaf3cc1c2c10"
};

export default firebaseConfig;
